<script>
import mc from '../../../api/mc'
import {mapGetters} from "vuex";

export default {
  name: 'slideVerify',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      companyInfo: 'companyInfo'
    })
  },
  data() {
    return {
      showModle: false,
      url: window.configure.imgUrl,
      imgObj: {
        // background: "FmDD60x0QgBJXMIVVHu22IBV39jY",
        // bloke: "FrqJIBhYmSLbI8Kx-Fv0aQKf7QL6",
        // height: 0.2857
      },
      progressValue: 0,
      startTime: 0,
      startX: 0,
    }
  },
  watch: {
    visible: {
      handler() {
        this.showModle = this.visible
        this.showModle && this.initPic()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    async initPic() {
      mc.getUsePic({
        phone: this.phone,
        type: 2,
        app_key:  this.companyInfo.app_key,
        company_id: this.companyInfo.id
      }, ({code, Pic}) => {
        console.log(code,222);
        if (code === 1) {
          this.imgObj = Pic
          this.initValue()
        }
      })
    },
    sliderDown(event) {
      console.log(event, 'sliderDown')
    },
    touchStartEvent(event) {
      this.startTime = Date.now()
      this.startX = event.changedTouches[0].pageX
    },
    outModel() {
      this.$emit('update:visible', false)
    },
    handleMoveEvent(event) {
      const x = event.changedTouches[0].pageX
      if (x > this.startX) {
        if (x - this.startX > 261) {
          this.progressValue = 261
        } else {
          this.progressValue = x - this.startX
        }
      } else {
        this.progressValue = 0
      }
    },
    initValue() {
      this.progressValue = 0
      this.startTime = 0
    },
    handleMoveEndEvent(event) {
      const x = event.changedTouches[0].pageX
      if (x > this.startX) {
        if (x - this.startX > 261) {
          this.progressValue = 261
        } else {
          this.progressValue = x - this.startX
        }
      } else {
        this.progressValue = 0
      }
      const endTime = new Date().getTime()
      const proportion = this.progressValue / 305
      this.$emit('dragEnd', {
        image_code: `${endTime - this.startTime},${proportion}`,
      })
    }

  }
}
</script>

<template>
  <div>
    <div class="slideVerify" v-if="showModle">
      <div class="popup-modal" @click="outModel"></div>
      <div class="content">
        <div style="position:absolute;right:20px;top:20px;" @click="outModel">
          <img src="../../../assets/img/login/close.png" style="width:16px;height:16px"/>
        </div>
        <div style="height: 12px"></div>
        <div class="popup-content-title" style="color: #666666">安全验证</div>
        <div style="color: #333333;font-size: 18px;font-weight: bold">拖动下方滑动完成拼图</div>
        <div style="height: 12px"></div>
        <div class="sliderImg">
          <img style="width:100%;height: 100%" :src="url+'/'+imgObj.background" alt="">
          <img :style="{'top':((1 - imgObj.height)*100)+'%','left':progressValue+'px'}" class="sliderImgBtn"
               :src="url+'/'+imgObj.bloke" alt="">
        </div>

        <div style="height: 12px"></div>

        <div class="movable-area">
          <div :style="{'left':progressValue+'px'}" class="movable-view" @mousedown="sliderDown"
               @touchstart="touchStartEvent"
               @touchmove="handleMoveEvent"
               @touchend="handleMoveEndEvent">
            <img v-if="loading" src="../../../assets/img/login/timg-loading.png" alt="">
            <img v-else src="../../../assets/img/login/slider-right.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.slideVerify {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 30;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-modal {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.content {
  width: 335px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 15px;
  box-sizing: border-box;
  border-radius: 12px;
  position: relative;

}

.sliderImg {
  width: 310px;
  height: 182px;
  position: relative;
}

.sliderImgBtn {
  width: 44px;
  height: 44px;
  position: absolute;

}

.movable-area {
  width: 100%;
  height: 40px;
  background-color: #f3f4f5;
  position: relative;
}

.movable-view {
  width: 44px;
  height: 40px;
  background: white;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 8;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all linear;

  img {
    width: 20px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// slideVerify.vue?5982646a